export default __webpack_public_path__ + "static/media/404.763b719c.jpg";